import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AtsSkeleton, Table } from '_atoms';
import { Typography } from '_atoms/Typography';
import { getCandidateJobs, getCandidateJobsLoading } from 'store/selectors/candidateSelectors';
import { ReactComponent as EmptyImage } from 'dist/emptyStates/dashboardOpening.svg';
import { useJobAssignedData } from './utils';
import { useColumns } from './constants';
import './style.scss';

type JobAssignedRow = ReturnType<typeof useJobAssignedData>[number];

interface JobAssignmentListProps {
  data: JobAssignedRow[];
}

const JobAssignmentList: React.FC<JobAssignmentListProps> = ({ data }) => {
  const { t } = useTranslation();

  const columns = useColumns(t);

  return (
    <div className="job-assigned_mobile">
      {data.map(d => (
        <div className="assignment-item">
          {columns.map(c => (
            <div className="assignment-item__row">
              <Typography.Text className="title">{c.title}:</Typography.Text>
              <div className="content">{c.render?.(d[c.key]) || (d[c.key] as React.ReactNode)}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export const JobAssignedTabContent: React.FC = () => {
  const { t } = useTranslation();
  const jobs = useJobAssignedData(useSelector(getCandidateJobs));
  const loading = useSelector(getCandidateJobsLoading);

  const columns = useColumns(t);

  if (loading)
    return (
      <div className="job-assigned__loading">
        <AtsSkeleton count={3} height={145} />
      </div>
    );
  if (!jobs.length)
    return (
      <div className="job-assigned__empty">
        <EmptyImage />
        <Typography.Text>{t('translation:job_assigned_tab_content.text_not_assigned')}</Typography.Text>
      </div>
    );

  return (
    <div className="job-assigned">
      <Table rowKey="id" columns={columns} data={jobs} showCardHeader={false} showCardFooter={false} />
      <JobAssignmentList data={jobs} />
    </div>
  );
};
